import { combineReducers } from "redux";
import authReducer from "./auth/reducer";
import usersReducer from "./users/reducer";
import decisionsReducer from "./decisions/reducer";

export const globalReducers = combineReducers({
    auth: authReducer,
    users: usersReducer,
    decisions: decisionsReducer,
});

export type RootState = ReturnType<typeof globalReducers>;
